// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__nkLCO","alert":"SettungsInbox_alert__1KTIZ"};